import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import {
  searchForRecentFood,
  searchForFood,
} from "../../../../features/mobile/mealSlice";
import SearchDialog from "./SearchDialog";
import { ReactComponent as Search } from "../../../../svg/search.svg";

const FoodInputBox = ({ onSaveAddorEdit }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const boxRef = useRef(null);
  const keywordRef = useRef(null);
  const [value, setValue] = useState(null);
  const [boxStatus, setBoxStatus] = useState("search"); // search: recent or searched foods, addQty: quantity input after completion
  const { loginInfo } = useSelector((state) => state.commonApp);
  const [noFoodOpen, setNoFoodOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [searchedFoodLists, setSearchedFoodLists] = useState([]); // Store data internally due to async issues
  console.log(searchedFoodLists, "searchedFoodLists");

  const onSearchForFood = () => {
    let params = { searchText: value, userId: loginInfo.userId };
    dispatch(searchForFood(params))
      .unwrap()
      .then((res) => {
        if (res.data.ok) {
          if (res.data.searchText === keywordRef.current) {
            // Important: exclude data from previous keyword if it arrives late
            if (res.data?.foodList?.length > 0) {
              setSearchedFoodLists(res.data.foodList);
              setNoFoodOpen(false);
            } else setNoFoodOpen(true);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const onChangeKeyEnter = (e) => {
    const key = e.code;
    const keyCode = e.keyCode;
    if (key === "Enter" || keyCode === 13) {
      onSearchForFood();
    }
  };

  const onFocusAction = () => {
    setOpenDialog(true);
    if (boxStatus === "addQty") setBoxStatus("search");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    inputRef.current.focus();
    setOpenDialog(true); // Open dialog immediately
    dispatch(searchForRecentFood({ userId: loginInfo.userId }));
  }, [dispatch, loginInfo.userId]);

  useEffect(() => {
    window.scrollTo(0, 0);
    const debounce = setTimeout(() => {
      if (value?.length > 0 && value !== setValue) {
        setOpenDialog(true);
        onSearchForFood();
      }
    }, 200);
    keywordRef.current = value;
    return () => clearTimeout(debounce);
    // eslint-disable-next-line
  }, [dispatch, value]);

  return (
    <>
      <div className="flex items-center rounded-xl border border-gray_60 bg-white pb-[18px] pl-3 pt-4">
        <input
          id="foodSearch"
          name="foodSearch"
          ref={inputRef}
          type={"text"}
          onFocus={onFocusAction}
          placeholder={t('meals:components.enter_food')}
          onChange={(e) => {
            boxRef?.current?.scrollIntoView({
              inline: "center",
              behavior: "instant",
            });
            setValue(e.target.value);
          }}
          value={value || ""}
          onKeyDown={onChangeKeyEnter}
          className={
            "h-[64] w-full appearance-none text-body3_500 focus:outline-none focus:ring-0 " +
            (value && boxStatus === "addQty" ? "text-gray_160" : "text-black")
          }
        />
        <label
          onClick={value ? onSearchForFood : null}
          htmlFor="foodSearch"
          className="pr-4"
        >
          <Search className="w-6 h-6" fill={value ? "#0D0D0D" : "#dedede"} />
        </label>
      </div>
      <div className="pt-5 text-center text-gray_160">
        <p className="text-caption2_700">
          {t('meals:components.cant_find_food_line1')}
          <br />
          {t('meals:components.cant_find_food_line2')}
          <br />
          <span className="text-caption2_400 ">
            {t('meals:components.cant_find_food_line3')}
          </span>
        </p>
      </div>
      <SearchDialog
        boxRef={boxRef}
        boxStatus={boxStatus}
        setBoxStatus={setBoxStatus}
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        keyword={value}
        setValue={setValue}
        onSaveAddorEdit={onSaveAddorEdit}
        noFoodOpen={noFoodOpen}
        setNoFoodOpen={setNoFoodOpen}
        searchedFoodLists={searchedFoodLists}
      />
    </>
  );
};

export default FoodInputBox;
